// src/pages/Kontakt.js
import React, { useState } from 'react';

const styles = {
  main: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '2rem',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '1.5rem',
  },
  successMessage: {
    padding: '1rem',
    backgroundColor: 'var(--color-primary)', // Koristimo vaše CSS varijable
    color: '#fff',
    borderRadius: '6px',
    textAlign: 'center',
    marginBottom: '1rem',
  },
  errorMessage: {
    padding: '1rem',
    backgroundColor: 'var(--color-error)',
    color: '#fff',
    borderRadius: '6px',
    textAlign: 'center',
    marginBottom: '1rem',
  },
};

export default function Kontakt() {
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const form = e.target;
    const data = new FormData(form);

    try {
      // OVDJE STAVITE VAŠ URL SA FORMSPREE-a
      const response = await fetch('https://formspree.io/f/meepovwg', {
        method: 'POST',
        body: data,
        headers: {
          'Accept': 'application/json',
        },
      });

      if (response.ok) {
        setStatus('success');
        form.reset(); // Očisti formu
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <main style={styles.main}>
      <h1 style={styles.title}>Kontakt</h1>
      
      {/* Poruke o statusu */}
      {status === 'success' && (
        <div style={styles.successMessage}>
          Poruka je uspješno poslana! Javićemo vam se u najkraćem roku.
        </div>
      )}
      {status === 'error' && (
        <div style={styles.errorMessage}>
          Došlo je do greške. Molimo pokušajte ponovo ili nas kontaktirajte putem emaila.
        </div>
      )}

      <form onSubmit={handleSubmit} className="card">
        <input type="text" name="_gotcha" style={{ display: 'none' }} />
  
        <div className="field-group">
          <label className="field-label" htmlFor="name">
            Ime i prezime
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            className="field-input"
            placeholder="Vaše ime..."
          />
        </div>

        <div className="field-group">
          <label className="field-label" htmlFor="email">
            Email adresa
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            className="field-input"
            placeholder="vas@email.com"
          />
        </div>

        <div className="field-group">
          <label className="field-label" htmlFor="subject">
            Naslov
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            required
            className="field-input"
            placeholder="Naslov poruke..."
          />
        </div>

        <div className="field-group">
          <label className="field-label" htmlFor="message">
            Poruka
          </label>
          {/* Koristimo field-input i za textarea radi konzistentnosti */}
          <textarea
            id="message"
            name="message"
            rows="5"
            required
            className="field-input"
            placeholder="Vaša poruka..."
            style={{ borderBottom: '1px solid var(--color-border)', resize: 'vertical' }}
          />
        </div>

        <button 
          type="submit" 
          className="clear-button" // Koristimo postojeću klasu za dugme
          style={{ width: '100%', marginTop: '10px' }}
          disabled={status === 'sending'}
        >
          {status === 'sending' ? 'Slanje...' : 'Pošalji poruku'}
        </button>
      </form>
    </main>
  );
}
